<style>
.setpsd {
  box-sizing: border-box;
  padding: 0 80px;
  background: #fff;
  overflow: hidden;
  padding-bottom: 300px;
  width: 1200px;
  height: 700px;
}
.setpsd.dialog{
  width: 100%;
  height: auto;
  padding: 0;
}

.set-form {
  margin-top: 100px;
}

.setpsd.dialog .set-form{margin-top: 0}

.set-input {
  width: 360px !important;
}

.setpsd .el-form-item {
  margin-bottom: 25px;
}
.dialogVisible .setpsd.dialog .el-form-item{
  margin-bottom: 25px;
}

.setpsd .el-input__inner {
  height: 45px;
  line-height: 45px;
  border-radius: 23px;
}
.set-submit {
  margin-top: 45px;
  margin-left: 250px;
}

.update-psd {
  font-size: 20px;
  font-weight: bold;
  text-align: center;
}
.tips {
  color: #f83b56;
  text-align: center;
  margin: 20px 0;
}

.setpsd.dialog .el-form-item__label,
.setpsd.dialog .el-form-item__error {
  margin-left: 150px
}
.setpsd.dialog .set-submit{
  margin-left: 160px
}
.dialogVisible .setpsd.dialog .el-form-item .el-form-item__content .el-form-item__error{
    top: 100%;
    left: 0;
}

.setpsd .el-form-item__label,
.setpsd .el-form-item__error {
  margin-left: 250px;
}
.set-submit .el-button {
  width: 115px!important;
  height: 46px;
}
</style>
<template>
  <div>
    <div class="content setpsd" :class="{'dialog':setpayPwd}">
      <el-form :model="ruleForm2" status-icon :rules="rules2" ref="ruleForm2" label-width="100px"
               class="demo-ruleForm set-form">
        <div class="update-psd">设置消费密码</div>
        <div class="tips">请让顾客自己设置消费密码，并提醒用户记住密码。后续服务开单均用该密码校验。</div>
        <el-form-item label="密码：" prop="pass">
          <el-input type="password" v-model="ruleForm2.pass" autocomplete="off" auto-complete="off" class="set-input" placeholder="请输入6位数密码"></el-input>
        </el-form-item>
        <el-form-item label="确认密码：" prop="checkPass">
          <el-input type="password" v-model="ruleForm2.checkPass" autocomplete="off" auto-complete="off" class="set-input" placeholder="请再次输入6位数密码"></el-input>
        </el-form-item>
        <el-form-item class="set-submit">
            <el-button class="darkBtn" @click="resetForm('ruleForm2')">取消</el-button>
            <el-button class="redBtn" :disabled="clickFalg" @click="submitForm('ruleForm2')">确定</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import {insertAccount, updateMemPsd } from "@/api";
import CryptoJS from 'crypto-js'

export default {
  props: ['setpayPwd','dialogSetpwd'],
  data() {
    var validatePass = (rule, value, callback) => {
      var reg = /^\+?[0-9][0-9]*$/;
      if (value === "") {
        callback(new Error("请输入密码"));
      } else if (!reg.test(value)) {
        callback(new Error("密码格式为数字，请设置正确格式的密码"));
      } else if (value.length < 6) {
        callback(new Error("密码太短"));
      } else if (value.length > 6) {
        callback(new Error("密码长度只可以是6位"));
      } else {
        if (this.ruleForm2.checkPass !== "") {
          this.$refs.ruleForm2.validateField("checkPass");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      var reg = /^\+?[0-9][0-9]*$/;
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (!reg.test(value)) {
        callback(new Error("密码格式为数字，请设置正确格式的密码"));
      } else if (value !== this.ruleForm2.pass) {
        callback(new Error("两次密码输入不一致！"));
      } else if (value.length < 6) {
        callback(new Error("密码太短"));
      } else if (value.length > 6) {
        callback(new Error("密码长度只可以是6位"));
      } else {
        callback();
      }
    };
    return {
      ruleForm2: {
        pass: "",
        checkPass: ""
      },
      rules2: {
        pass: [{ required: true, message: '请输入密码', trigger: 'change' },{ validator: validatePass, trigger: "blur" }],
        checkPass: [{ required: true, message: '请再次输入密码', trigger: 'change' },{ validator: validatePass2, trigger: "blur" }]
      },
      clickFalg:false
    };
  },
  watch: {
    'dialogSetpwd'(val){
      if(val){
        this.$refs.ruleForm2.resetFields();
        this.ruleForm2 = this.$options.data().ruleForm2
      }
    }
  },
  methods: {
    operaEntryDES(message) {
      var keyHex = CryptoJS.enc.Utf8.parse("VIP20198888*7*6*5*4**88882088VIP");
      var encrypted = CryptoJS.TripleDES.encrypt(message, keyHex, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
      });
      return encrypted.toString();
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.clickFalg = true;
          let postData = {
            memberId:this.setpayPwd?this.setpayPwd.memberId:sessionStorage.getItem('memId'),
            updateFlag: '1',
            passwordOff: this.operaEntryDES(this.ruleForm2.pass)
          };

          if(this.setpayPwd&&this.setpayPwd.setpayPwd == 2){
            // 加入本店会员
            insertAccount({
                memberId:this.setpayPwd.memberId
            }).then(res=>{
                if (res.code == 1) {
                    sessionStorage.setItem("memId", this.setpayPwd.memberId);
                    // 进入消费密码设置页
                    this.postPwd(postData)
                }
                this.$message({
                    type: res.code == 1 ? "success":'error',
                    message: res.msg
                });
            })
          }else{
            this.postPwd(postData)
          }
          
          
        } else {
          this.clickFalg = false;
          console.log("error submit!!");
          return false;
        }
      });
    },
    postPwd(postData){
      const date = updateMemPsd(postData);
      date.then(res => {
          this.$message({
            message: res.msg,
            type: res.code == 1 ? "success" : "error"
          });
          if (res.code == 1) {
            if(this.setpayPwd){
              // 开始服务设置密码
              this.$emit('closeset',false)
            }else{
              sessionStorage.removeItem('memId');
              this.$store.commit("delete_tabs", "/basicDataCenter/setPsd");
              this.$store.commit("setAliveStatus", true);//保留列表页状态
              this.$router.push('/basicDataCenter/baseInfo');
            }
          }
          setTimeout(()=>{
            this.clickFalg = false;
          })
        })
        .catch(error => {
          this.$message({
            message: "网络连接失败，请稍后再试",
            type: "error"
          });
        });
    },
    resetForm(formName) {
      if(this.setpayPwd){
        this.$emit('closeset',false)
      }
      this.$refs[formName].resetFields();
    }
  }
};
</script>





// WEBPACK FOOTER //
// src/components/basicDataCenter/setPsd.vue